"use strict";
var React = require('react')
var Link = require('react-router').Link
var GalleryStore = require('../../store/GalleryStore')
var galleryAction = require('../../actions/galleryAction');
var _ = require('underscore')
var Loader = require('react-loader');
var DocMeta = require('react-doc-meta');

var Galerija = React.createClass({
    componentDidMount() {
        GalleryStore.addChangeListener(this.onChange);
        galleryAction.getGal();
        var title = this.state.lang === 'uk' ? 'Gallery | Termovent SC Steal foundry A.D. Bačka Topola' : this.state.lang === 'rs' ? "Galerija | Termovent SC Livnica čelika A.D. Bačka Topola" : "Galerie | Die Termovent SC Stahlfabrik"
        document.title = title;
    },
    componentWillUnmount() {
        GalleryStore.removeChangeListener(this.onChange);
    },
    getInitialState() {
        var state = GalleryStore.getGallery();
        return state;
    },
    onChange() {
        var state = GalleryStore.getGallery();
        this.setState(state);
    },
    galList(){
      var listItems = _.map(this.state.data, function(pic, index){
       //var url = this.props.routes[2].path === '/eng/' || this.props.routes[2].path === '/ger/' ? '../img/galerija/cover/' : 'img/galerija/cover/'
        var src = 'img/galerija/cover/'+pic.cover
        var galerija = {
          naziv: pic.naziv
        }
        return (

        <div className="col-md-4" key={index}>
          <div className="thumbnail proizvod">
            <Link to={'/galerija/'+pic.galerija_id}>
              <img className='gallery' src={src}/>
              <div className="caption text-center">
                <h3>{pic.naziv}</h3>
              </div>
             </Link>
          </div>
        </div>
       )
      })
      return(listItems);
    },
  render() {

    return (
     <Loader loaded={this.state.fetched}>
      <div className='container'>
      <div className='index-content row'>
        <div className='galHolder'>
          {this.galList()}
        </div>
      </div>
      </div>
      </Loader>
    )
  }
})

module.exports = Galerija;



/** WEBPACK FOOTER **
 ** ./modules/components/Galerija/Galerija.js
 **/